import axios from "axios";
import { API_NAPCOBRANZAS } from "config/api.config";
import UserService from "config/UserService";

export const getCompaniesNapCobranzas = async () => {
  const res = await axios.get(`${API_NAPCOBRANZAS}/client/${UserService.company()}`, {
    headers: { Authorization: UserService.token() },
  });
  return res.data;
};

export const postClients = async (data) => {
  const res = await axios.post(`${API_NAPCOBRANZAS}/client`, data, {
    headers: { Authorization: UserService.token() },
  });
  return res.data;
};

export const putClients = async (data, id) => {
  let res = await axios.put(`${API_NAPCOBRANZAS}/client/${id}`, data, {
    headers: { Authorization: UserService.token() },
  });
  return res.data;
};
